let nextId = 0;
export default {
  namespaced: true,

  state: {
    notifications: [],
    updatedHarps: false,

    showWhyDiscount: false,
    mouseXPosition: '0',
    mouseYPosition: '0',
  },

  getters: {
    notifications(state) {
      return state.notifications;
    },

    updatedHarps(state) {
      return state.updatedHarps;
    },

    showWhyDiscount(state) {
      return state.showWhyDiscount;
    },

    mouseXPosition(state) {
      return state.mouseXPosition;
    },

    mouseYPosition(state) {
      return state.mouseYPosition;
    },
  },

  mutations: {
    PUSH(state, notification) {
      state.notifications.push({
        ...notification,
        id: nextId += 1,
      });
    },

    DELETE(state, notificationToRemove) {
      state.notifications = state.notifications.filter((notification) => notification.id !== notificationToRemove.id);
    },

    UPDATED_HARPS(state, value) {
      state.updatedHarps = value;
    },

    SHOW_WHY_DISCOUNT(state) {
      state.showWhyDiscount = !state.showWhyDiscount;
    },

    SET_MOUSE_X_POSITION(state, value) {
      state.mouseXPosition = value;
    },

    SET_MOUSE_Y_POSITION(state, value) {
      state.mouseYPosition = value;
    },
  },

  actions: {
    add({ commit }, notificationToAdd) {
      commit('PUSH', notificationToAdd);
    },
    remove({ commit }, notificationToRemove) {
      commit('DELETE', notificationToRemove);
    },

    updatedHarps({ commit }, value) {
      commit('UPDATED_HARPS', value);
    },

    showWhyDiscount({ commit }) {
      commit('SHOW_WHY_DISCOUNT');
    },

    setMouseXPosition({ commit }, xCoordinate) {
      commit('SET_MOUSE_X_POSITION', xCoordinate);
    },
    setMouseYPosition({ commit }, yCoordinate) {
      commit('SET_MOUSE_Y_POSITION', yCoordinate);
    },
  },
};
